import { json, MetaFunction, useLoaderData } from "@remix-run/react";
import { rechtstexte } from "~/content/rechtstexte";
import { HeadersFunction } from "@remix-run/node";
import { indexFollow } from "~/constants/meta";

export const headers: HeadersFunction = () => {
  return {
    "Cache-Control":
      "public, max-age=60, s-maxage=1800, stale-while-revalidate=86400",
  };
};

export const meta: MetaFunction<typeof loader> = () => {
  const pageUrl = "https://updrinks.de/impressum";

  return [
    indexFollow,
    {
      tagName: "link",
      rel: "canonical",
      href: pageUrl,
    },
    {
      title: `Impressum - UPdrinks`,
    },
    {
      name: "description",
      content: `Das Impressum von UPdrinks. Finden Sie hier alle rechtlichen Informationen und Kontaktmöglichkeiten zu unserem Unternehmen.`,
    },
  ];
};

/*export const headers: HeadersFunction = () => ({
  "Cache-Control": "s-maxage=86400, stale-while-revalidate=604800",
});*/

export async function loader() {
  const data = { impressum: rechtstexte.impressum };

  return json(data, {
    headers: {
      "Cache-Control":
        "public, max-age=300, s-maxage=86400, stale-while-revalidate=604800",
    },
  });
}

export default function Impressum() {
  const data = useLoaderData<typeof loader>();

  return (
    <main className="mx-auto min-h-screen max-w-[60rem] overflow-x-hidden">
      <div className="py-14 md:py-[4.5rem]">
        <div
          className="prose prose-invert mt-10 max-w-screen-xl text-wrap px-5 text-white sm:prose-xl md:mt-20"
          dangerouslySetInnerHTML={{
            __html: data.impressum.content,
          }}
        />
      </div>
    </main>
  );
}
